import _, { find, cloneDeep } from 'lodash';
import moment from 'moment';

import { displayDate } from 'common/utils/date-time';
import { isValidContact } from 'common/utils/order-utils-typed';
import { generatePdf } from 'common/services/OrderService';
import Alert from 'common/components/Alert';
import { getContractor } from 'common/services/AuthService';
import * as logger from 'common/utils/Logger';
import * as AuthService from 'common/services/AuthService';
import { ORDER_FULFILLMENT_TYPE } from 'common/stores/redux/MetaStore/MetaStoreApi.types';

export const handleLogisticsDateRange = (activeLogistic, fulfillmentTypeId) => {
    if (!activeLogistic) {
        return;
    }
    switch (fulfillmentTypeId) {
        case 'PICK_UP': {
            return displayDate(activeLogistic.expectedAvailabilityStart);
        }
        case 'DELIVERY': {
            return handleDeliveryAvailablity(activeLogistic);
        }
        default:
            return '';
    }
};

export const sanitizeInput = str =>
    str.replace(/[^\x20-\x7E]+/g, '').replace(/[&]/g, 'and');

const handleDeliveryAvailablity = activeLogistic => {
    let expectedAvailability;
    const { expectedAvailabilityEnd, expectedAvailabilityStart } =
        activeLogistic;
    if (expectedAvailabilityEnd) {
        if (
            moment(expectedAvailabilityEnd).isSame(
                expectedAvailabilityStart,
                'day'
            )
        ) {
            expectedAvailability = `${displayDate(expectedAvailabilityStart)}`;
        } else {
            expectedAvailability = `${displayDate(
                expectedAvailabilityStart
            )} - ${displayDate(expectedAvailabilityEnd)}`;
        }
    } else {
        expectedAvailability = `${displayDate(expectedAvailabilityStart)}`;
    }
    return expectedAvailability;
};

// export function alertSwitch({details, alertType = 'success'}) {
//     const {number, action, categoryId, message} = details;
//     if (!categoryId) {
//         // eslint-disable-next-line no-console
//         console.error('Invalid invocation of the alert switch.');
//         return null;
//     }
//     if (message) {
//         return Alert[alertType](message, {position: 'top'});
//     }
//     const failureText = 'please contact support@motili.com for additional assistance.';
//     const ALERTS = {
//         creation: {
//             success: `Successfully created Order #${number}`,
//             error: `There was an error creating the Order, ${failureText}`
//         },
//         init: {
//             success: '',
//             error: `There was an error fetching the Order id:${number}, ${failureText}`
//         },
//         update: {
//             success: `Successfully updated Order #${number}.`,
//             error: `There was an error updating Order #${number}, ${failureText}`
//         },
//         updateLineItem: {
//             success: `Successfully updated line item on Order #${number}.`,
//             error: `There was an error updating line item on Order #${number}, ${failureText}`
//         },
//         deleteLineItem: {
//             success: `Successfully deleted line item on Order #${number}.`,
//             error: `There was an error deleting line item on Order #${number}, ${failureText}`
//         },
//         action: {
//             success: `Successfully performed ${action} action on Order #${number}.`,
//             error: `There was an error performing ${action} action on Order #${number}, ${failureText}`
//         }
//     };
//     // errors should stick success should not
//     return Alert[alertType](ALERTS[categoryId][alertType], {position: 'top'});
// }

// export function shouldOrderButtonRender(props) {
//     console.log('SHOULD ORDE RBUTTON RENDER', props)
//     const extendable = {...props};
//     if (!extendable.order) extendable.order = extendable.document;
//     if (!extendable.order) return false;
//     if (extendable.fulfillmentTypeId === 'DELIVERY') return true;
//     if (!extendable.selectedDistributionCenter) return false;
//     if (!extendable.selectedDistributionCenter.inventory) return false;
//     if (!extendable.selectedDistributionCenter.inventory.length) return false;
//     if (extendable.selectedDistributionCenter.canFulfill !== 1) return false;
//     return true;
// }

// export function shouldFormBeDisabled(status) {
//     if (!status) return false;
//     if (status !== 'CREATED') return true;
//     return false;
// }

// export function isValidOrder(order) {
//     if (order.tradeSubTypeId) return true;
//     if (order.tradeTypeId) return true;
//     if (order.tradeTypeId) return true;
//     if (order.contact.name) return true;
//     if (order.contact.email && !order.contact.mobile) return true;
//     if (order.contact.email && !Validator.isEmail(order.contact.email)) return true;
//     if (order.contact.mobile && !Validator.isPhone(order.contact.mobile)) return true;
//     return false;
// }

export function mapFulfillmentDetailsToOrder(details) {
    const order = cloneDeep(details.order);
    if (order.fulfillmentTypeId === 'PICK_UP') {
        const center = { ...details.selectedDistributionCenter };
        order.fulfillmentDistributionCenterId = center.id;
        order.fulfillmentTo = center.vendorBranchName;
        order.fulfillmentToAddress = `${center.stdDeliveryLine} ${
            center.stdLastLine ? center.stdLastLine : ''
        }`;
        order.fulfillmentToCity = center.stdCity;
        order.fulfillmentToPostalCode = center.stdPostalCode;
        order.fulfillmentToRegion = center.stdRegion;
    } else if (order.fulfillmentTypeId === 'DELIVERY') {
        const address = { ...details.selectedDeliveryAddress.components };
        order.fulfillmentTo = address.name;
        order.fulfillmentToAddress = address.deliveryLine;
        order.fulfillmentToCity = address.city;
        order.fulfillmentToPostalCode = address.zip;
        order.fulfillmentToRegion = address.state;
        order.fulfillmentDistributionCenterId = null;
    }
    return order;
}

/**
 * basic validation of an order
 * @param {object} order
 * @param {string} [order.tradeSubTypeId]
 * @param {string} [order.tradeTypeId]
 * @param {string} [order.priorityId]
 * @param {object[]} [order.contacts]
 * @param {object} rules
 * @param {string} rules.extPoNumber
 * @param {string} rules.extReferenceNumber1
 * @param {string} rules.extReferenceNumber2
 * @param {string} rules.instructions.special
 * @returns {boolean}
 */
export function isValid(order, rules) {
    if (!order) {
        return false;
    }
    if (!order.clientId) {
        return false;
    }
    if (!order.tradeSubTypeId) {
        return false;
    }
    if (!order.tradeTypeId) {
        return false;
    }
    if (!order.priorityId) {
        return false;
    }
    if (!order.extPoNumber) {
        return false;
    }
    if (order.hasFulfillmentMethods && !order.fulfillmentMethod) {
        return false;
    }
    if (order.propertyRequired && !order.propertyId) {
        return false;
    }
    if (rules) {
        if (rules.PORequired && !validInput(order.extPoNumber)) {
            return false;
        }
        if (rules.refOneRequired && !validInput(order.extReferenceNumber1)) {
            return false;
        }
        if (rules.refTwoRequired && !validInput(order.extReferenceNumber2)) {
            return false;
        }
        if (
            rules.instructionsRequired &&
            !validInput(order.instructions.special)
        ) {
            return false;
        }
    }

    if (!Array.isArray(order.contacts) || order.contacts.length === 0) {
        return false;
    }
    const invalidContacts = order.contacts.filter(c => {
        if (!c) return false;
        return !isValidContact(c);
    });
    if (invalidContacts.length > 0) {
        return false;
    }
    return true;
}

/**
 * trims white space and makes sure length is
 * 3 or more characters for string inputs
 * @export
 * @param {string} value
 * @returns
 */
export function validInput(value) {
    return trimWhiteSpace(value)?.length >= 3;
}

/**
 * removes white space
 *
 * @export
 * @param {string} value
 */
export function trimWhiteSpace(value) {
    return value?.trim();
}

export function calculateAddOnFreight(freightOptions) {
    const freightOptionsRate = parseFloat(freightOptions?.rate);
    if (freightOptionsRate.isNaN) {
        return 0;
    }
    return freightOptionsRate;
}

export function isEquipmentOrderOnly(client, orderTypeId) {
    const lineOfBusiness = client?.settings?.find(
        s => s.settingTypeId === 'LINE_OF_BUSINESS'
    )?.setting?.lineOfBusiness;
    return !!(orderTypeId === 'ORDER' && lineOfBusiness === 'EQUIPMENT');
}

export function shouldDisplayOrderIssues(statusesSelected) {
    if (!statusesSelected) {
        return false;
    }
    return !!find(statusesSelected, status => status.term === 'SUBMITTED');
}

export async function handleExportButtonClick(
    orderId,
    order,
    fileName,
    hidePricing,
    setBusySpinnerProps,
    setExportModal
) {
    try {
        setBusySpinnerProps({ busy: true });
        const startTime = new Date();
        const response = await generatePdf(
            orderId,
            fileName,
            order.instructions.special,
            order.lineItems.map(item => item.id),
            hidePricing
        );
        const endTime = new Date();
        let timeElapsed = endTime - startTime;
        timeElapsed /= 1000;
        setExportModal({
            exportLink: response,
            message: `PDF for Order #${order.number} was successfully generated.`,
            timeElapsed,
            show: true,
        });
    } catch (error) {
        logger.error(error);
        Alert.error(error.message);
    } finally {
        setBusySpinnerProps({ busy: false });
    }
}

export function showContractorProductPricing(payeeClientId) {
    // If the contractor is paying for the order, they can see pricing
    const contractor = getContractor();
    return (
        contractor?.clientPaymentAccountId &&
        contractor.clientPaymentAccountId === payeeClientId
    );
}

export function buildOrderCancelReasonsOptions(orderCancelReasons, action) {
    if (!orderCancelReasons) {
        return [];
    }
    let userType;

    if (AuthService.isMotiliAccount()) {
        userType = 'motili';
    } else if (AuthService.isClientAccount()) {
        userType = 'client';
    } else if (AuthService.isContractorAccount()) {
        userType = 'contractor';
    }
    if (!userType) {
        return [];
    }

    const primaryReasons = _.chain(Object.values(orderCancelReasons))
        .filter(
            reason =>
                !reason.disabled &&
                reason.actions?.includes(action) &&
                (!reason.allowedUserTypes ||
                    reason.allowedUserTypes.includes(userType))
        )
        .map(reason => ({
            ..._.pick(reason, ['id', 'display']),
            isPrimary: true, // add flag to handle data before submit to backend
            reasons: reason.reasons
                ? _.chain(Object.values(reason.reasons))
                      .filter(
                          sReason =>
                              !sReason.disabled &&
                              !sReason.systemOnly &&
                              (!sReason.allowedUserTypes ||
                                  sReason.allowedUserTypes.includes(userType))
                      )
                      .map(sReason => _.pick(sReason, ['id', 'display']))
                      .sortBy('display')
                      .value()
                : [],
        }))
        .sortBy('display')
        .value();

    const secondaryReasons = _.chain(primaryReasons)
        .flatMap(pr => pr.reasons || [])
        .map(r => ({
            ...r,
            reasons: _.filter(primaryReasons, pr =>
                _.some(pr.reasons, prs => prs.id === r.id)
            ),
        }))
        .value();

    // Combine primary and secondary reasons
    return _.chain([...primaryReasons, ...secondaryReasons])
        .groupBy('id') // Group by 'id' to merge duplicates
        .map((group, id) => ({
            id,
            isPrimary: group[0].isPrimary,
            display: group[0].display, // Assuming display is the same for the same ID
            reasons: _.chain(group)
                .flatMap('reasons')
                .uniqBy('id')
                .sortBy('display')
                .value(), // Merge reasons and remove duplicates
        }))
        .sortBy('display')
        .value();
}

export function validateOrderCancelReasonSelection(
    reasonSelection,
    secondaryReasonSelection
) {
    if (!reasonSelection) {
        return false;
    }
    return !(reasonSelection?.reasons?.length > 0 && !secondaryReasonSelection);
}

export function transformOrderCancelReasonSelection(
    reasonSelection,
    secondaryReasonSelection
) {
    const transformData = {
        reasonId: reasonSelection?.id,
        secondaryReasonId: secondaryReasonSelection?.id,
    };
    if (secondaryReasonSelection?.isPrimary) {
        // Secondary Reason was selected before Primary Reason on UI
        transformData.reasonId = secondaryReasonSelection?.id;
        transformData.secondaryReasonId = reasonSelection?.id;
    }

    return transformData;
}

export function getDefaultSecondaryOrderCancelReason(reason) {
    return reason?.reasons?.length === 1 ? reason?.reasons[0] : undefined;
}

export function getFulfillmentTypeIdFromVendor(vendorOrder) {
    let typeId = vendorOrder?.vendorFulfillmentType ?? '';
    if (typeId.charAt(0).toUpperCase() === 'P') {
        typeId = ORDER_FULFILLMENT_TYPE.PICK_UP;
    } else if (
        typeId.charAt(0).toUpperCase() === 'S' ||
        typeId.charAt(0).toUpperCase() === 'D' ||
        typeId.charAt(0).toUpperCase() === 'O'
    ) {
        typeId = ORDER_FULFILLMENT_TYPE.DELIVERY;
    }
    return typeId;
}

export function inferScopeFromOrder(order) {
    if (!order) {
        return {};
    }
    return {
        clientId: order.clientId,
        contractorId: order.contractorId,
        priceBookClientId: order.priceBookClientId,
        vendorId: order.vendorId || order.vendorDistributionCenter?.vendorId,
        priorityId: order.priorityId,
        postalCode:
            order.fulfillmentToStdPostalCode || order.fulfillmentToPostalCode,
        country:
            order.fulfillmentToStdCountry || order.client?.operationInCountry,
        region: order.fulfillmentToStdRegion || order.fulfillmentToRegion,
        county: order.fulfillmentToStdCounty,
        distributionCenterId: order.fulfillmentDistributionCenterId,
        projectId: order.job?.projectId,
    };
}
